<template>
  <div
    class="home"
    v-loading.fullscreen="loading"
    element-loading-background="rgba(255, 255, 255, 1)"
    element-loading-text="加载中......"
  >
    <!-- 轮播图 -->
    <section class="home-carousel">
      <template>
        <el-carousel class="homepage-carousel" :interval="5000" height="420px">
          <el-carousel-item
            v-for="(item, index) in carouselPicData"
            :key="index"
          >
            <a :href="item.link_url" target="_blank" v-if="item.link_url">
              <img v-if="item.picture" :src="BASE_URL + item.picture" />
            </a>
            <a v-else>
              <img v-if="item.picture" :src="BASE_URL + item.picture" />
            </a>
          </el-carousel-item>
        </el-carousel>
      </template>
    </section>

    <!-- 学时排行 homeSet.ranking_show-->
    <section
      class="i_application maxW"
      v-if="homeSet.ranking_show"
      style="width: 100%"
    >
      <div
        class="i_applicationTitle clear"
        style="display: flex; justify-content: space-between"
      >
        <div>学时排行</div>
        <div class="chart_more" @click="showModel()">
          <span>查看详情</span>
          <i class="ipng el-icon-caret-right"></i>
        </div>
      </div>
      <div class="class_hour">
        <div class="nav_title">
          <div
            class="title"
            @click="getChartList(item.id, index, 'card')"
            :class="{ checked: index == checknews }"
            :checked="index == checknews"
            v-for="(item, index) of chartData"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="content">
          <template v-if="CardList.length">
            <div v-for="(item, q) in CardList" :key="q">
              <div class="row" v-if="q < 3">
                <img
                  :src="require('@/assets/images/home/' + (q + 1) + '.png')"
                />
                <div class="name_d">
                  <template v-if="!checknews">
                    <img
                      :src="
                        checkPath(item.avatar_path)
                          ? item.avatar_path
                          : BASE_URL + item.avatar_path
                      "
                      style="border-radius: 30px"
                      v-if="item && item.avatar_path"
                    />
                    <img
                      src="../../../../assets/images/home/no_head.png"
                      v-else
                    />
                  </template>
                  <span>{{ item.name }}</span>
                </div>
                <div style="color: #999999">{{ item.org_name }}</div>
                <div class="min">{{ parseInt(item.total_time / 60) }}min</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="text-align: center">
              <img src="../../../../assets/images/v2/no_data.png" />
            </div>
          </template>
        </div>
      </div>
    </section>

    <!-- 热门视频 -->
    <section class="i_application maxW" v-if="homeSet.hotvideo_show">
      <div class="i_applicationTitle clear">
        <span>{{ $t("homepage.hotVideo") }}</span>
        <router-link to="/home/openclassList" tag="a" class="itc-more">
          {{ $t("homepage.moreVideo") }}
          <i class="ipng el-icon-caret-right"></i>
        </router-link>
      </div>
      <div class="i_hotBox">
        <ul class="clear" id="hot_video">
          <template v-for="(item, index) of hotVideoData">
            <li
              class="i_hotList wow bounceInLeft fl pointer"
              v-if="item"
              :key="index"
            >
              <a @click="turnDetails(item)" href="javascript:;">
                <img
                  :src="
                    item.picture.indexOf('http') == -1
                      ? BASE_URL + item.picture
                      : item.picture
                  "
                  :onerror="errorImg"
                />
              </a>
              <a
                @click="turnDetails(item)"
                href="javascript:;"
                class="i_ellipsis"
                :title="item.video_name"
                >{{ item.video_name }}</a
              >
              <div class="i_speType clear">
                <div
                  class="speCate"
                  :title="
                    item.avatar_path
                      ? item.avatar_path
                      : $t('global.defaultSort')
                  "
                >
                  <span class="avatat_span">
                    <img v-if="item.avatar_path" :src="item.avatar_path" />
                  </span>
                  {{
                    item.custom_speaker
                      ? item.custom_speaker
                      : $t("global.defaultSort")
                  }}
                </div>
                <p class="sawPeo">
                  <i class="el-icon-view"></i>
                  {{ item.clicks ? item.clicks : 0
                  }}{{ $t("customer.unit1") }}
                </p>
              </div>
              <i v-if="item.is_nice == 1" class="is-nice"></i>
            </li>
            <li class="i_hotList wow bounceInLeft fl" v-else :key="item">
              <div class="placeholder"></div>
            </li>
          </template>
        </ul>
      </div>
    </section>

    <!-- 专项训练营 -->
    <section class="i_application maxW" v-if="homeSet.special_show">
      <div class="i_applicationTitle clear">
        <span>{{ $t("homepage.special_tcamp") }}</span>
        <!-- <router-link to="/home/openclassList" tag="a" class="itc-more">
          {{ $t("homepage.moreVideo") }}
          <i class="ipng el-icon-caret-right"></i>
        </router-link> -->
      </div>
      <div class="i_hotBox">
        <ul class="clear" id="hot_video">
          <template v-for="(item, index) of specialareaArr">
            <li
              class="i_hotList wow bounceInLeft fl pointer"
              v-if="item"
              :key="index"
            >
              <a @click="goToDetails(item)" href="javascript:;">
                <img
                  :src="
                    item.picture.indexOf('http') == -1
                      ? BASE_URL + item.picture
                      : item.picture
                  "
                  :onerror="errorImg"
                />
              </a>
              <a
                @click="goToDetails(item)"
                href="javascript:;"
                class="i_ellipsis"
                :title="item.name"
                >{{ item.name }}</a
              >
              <div class="i_speType clear">
                <div
                  class="speCate"
                  :title="
                    item.cate_name ? item.cate_name : $t('global.defaultSort')
                  "
                >
                  {{
                    item.custom_speaker
                      ? item.custom_speaker
                      : $t("global.defaultSort")
                  }}
                </div>
                <p class="sawPeo">
                  <i class="el-icon-view"></i>
                  {{ item.usercount ? item.usercount : 0
                  }}{{ $t("customer.unit1") }}
                </p>
              </div>
              <div class="originCte">
                {{ item.origin ? $t("homepage.album") : $t("homepage.video") }}
              </div>
            </li>
            <li class="i_hotList wow bounceInLeft fl" v-else :key="item">
              <div class="spePholder"></div>
            </li>
          </template>
        </ul>
      </div>
    </section>
    <!-- 新上好课 -->
    <section class="i_application maxW" v-if="homeSet.product_show">
      <div class="i_applicationTitle clear">
        <span>{{ $t("homepage.product_focus") }}</span>
      </div>
      <div class="i_hotBox">
        <ul class="clear" id="hot_video">
          <template v-for="(item, index) of productArr">
            <li
              class="i_hotList wow bounceInLeft fl pointer"
              v-if="item"
              :key="index"
            >
              <a @click="goToDetails(item)" href="javascript:;">
                <img
                  :src="
                    item.picture.indexOf('http') == -1
                      ? BASE_URL + item.picture
                      : item.picture
                  "
                  :onerror="errorImg"
                />
              </a>
              <a
                @click="goToDetails(item)"
                href="javascript:;"
                class="i_ellipsis"
                :title="item.name"
                >{{ item.name }}</a
              >
              <div class="i_speType clear">
                <div
                  class="speCate"
                  :title="
                    item.avatar_path
                      ? item.avatar_path
                      : $t('global.defaultSort')
                  "
                >
                  <span class="avatat_span">
                    <img v-if="item.avatar_path" :src="item.avatar_path" />
                  </span>
                  {{
                    item.custom_speaker
                      ? item.custom_speaker
                      : $t("global.defaultSort")
                  }}
                </div>
                <p class="sawPeo">
                  <i class="el-icon-view"></i>
                  {{ item.usercount ? item.usercount : 0
                  }}{{ $t("customer.unit1") }}
                </p>
              </div>
              <div class="originCte">
                {{ item.origin ? $t("homepage.album") : $t("homepage.video") }}
              </div>
            </li>
            <li class="i_hotList wow bounceInLeft fl" v-else :key="item">
              <div class="spePholder"></div>
            </li>
          </template>
        </ul>
      </div>
    </section>
    <!-- 精品推荐 -->
    <section class="i_application maxW" v-if="homeSet.nicevideo_show">
      <div class="i_applicationTitle clear">
        <span>{{ $t("homepage.nice_video") }}</span>
      </div>
      <div class="i_hotBox">
        <ul class="clear" id="hot_video">
          <template v-for="(item, index) of niceVideoArr">
            <li
              class="i_hotList wow bounceInLeft fl pointer"
              v-if="item"
              :key="index"
            >
              <a @click="goToDetails(item)" href="javascript:;">
                <img
                  :src="
                    item.picture.indexOf('http') == -1
                      ? BASE_URL + item.picture
                      : item.picture
                  "
                  :onerror="errorImg"
                />
              </a>
              <a
                @click="goToDetails(item)"
                href="javascript:;"
                class="i_ellipsis"
                :title="item.name"
                >{{ item.name }}</a
              >
              <div class="i_speType clear">
                <div
                  class="speCate"
                  :title="
                    item.avatar_path
                      ? item.avatar_path
                      : $t('global.defaultSort')
                  "
                >
                  <span class="avatat_span">
                    <img v-if="item.avatar_path" :src="item.avatar_path" />
                  </span>
                  {{
                    item.custom_speaker
                      ? item.custom_speaker
                      : $t("global.defaultSort")
                  }}
                </div>
                <p class="sawPeo">
                  <i class="el-icon-view"></i>
                  {{ item.usercount ? item.usercount : 0
                  }}{{ $t("customer.unit1") }}
                </p>
              </div>
              <div class="originCte">
                {{ item.origin ? $t("homepage.album") : $t("homepage.video") }}
              </div>
            </li>
            <li class="i_hotList wow bounceInLeft fl" v-else :key="item">
              <div class="spePholder"></div>
            </li>
          </template>
        </ul>
      </div>
    </section>

    <!-- 新闻公告 -->
    <section class="i_application maxW clear">
      <div class="i_applicationTitle clear">
        <span>{{ $t("homepage.news") }}</span>
        <router-link to="/home/newsList">
          {{ $t("homepage.more") }}新闻
          <i class="ipng el-icon-caret-right"></i>
        </router-link>
      </div>
      <div class="notice_d">
        <div class="nav_title">
          <div
            style="cursor: pointer"
            class="title"
            @click="getNewsList(item.id, index)"
            :class="{ checked: index == checknews }"
            :checked="index == checknews"
            v-for="(item, index) of newsData"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="content" v-if="noticeData.length">
          <div
            class="grid-item"
            v-for="(item, index) in noticeData"
            :key="index"
            @click="showNoticeDetail(item)"
            style="cursor: pointer"
          >
            <div class="left_d">
              <img src="../../../../assets/images/homepage/itc-date.png" />
              <div
                class="text"
                style="
                  position: absolute;
                  top: 30%;
                  text-align: center;
                  left: 22%;
                "
              >
                <span>{{ item.time }}</span>
                <span style="color: #fad2d3">{{ item.data }}</span>
              </div>
            </div>
            <div style="padding-left: 10px; margin-top: 5px">
              <div class="title">{{ item.name }}</div>
              <div v-html="item.content" class="detail"></div>
            </div>
          </div>
        </div>
        <template v-else>
          <div
            style="
              text-align: center;
              width: 100%;
              align-items: center;
              margin-top: 3%;
            "
          >
            <img src="../../../../assets/images/v2/no_data.png" />
          </div>
        </template>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="i_application about_d" v-if="homeSet.aboutus_show">
      <div class="content maxW">
        <div class="text_content">
          <div class="i_applicationTitle">
            <span class="title">{{ $t("homepage.aboutUs") }}</span
            ><span class="en">ABOUT US</span>
          </div>
          <div
            class="itc_content"
            :class="CampusStyleData.content ? 'container' : 'container bgc'"
            v-html="CampusStyleData.content"
          ></div>
        </div>
        <div class="i_companyImg fl">
          <img
            v-if="CampusStyleData.picture"
            :src="BASE_URL + CampusStyleData.picture"
          />
          <span class="name">广东保伦电子股份有限公司</span>

          <div class="text"></div>
        </div>
      </div>
      <div class="red_bg"></div>
    </section>

    <!-- 排行榜 弹框 -->
    <el-dialog
      title="学时排行"
      close="dialog_chart"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div style="display: flex">
        <div class="chart_class">
          <div
            class="title"
            @click="getChartList(item.id, index, 'table')"
            :class="{ checked: index == checknews }"
            :checked="index == checknews"
            v-for="(item, index) of chartData"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="chart_table">
          <div class="ranktext">
            {{ !checknews ? "个人" : "部门" }}排名：{{
              rankText ? "rankText" : "未上榜"
            }}
          </div>

          <div style="position: absolute; top: 70px; right: 20px">
            <el-date-picker
              :clearable="false"
              class="month_input"
              @change="onDatePicker"
              v-model="dataPreMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
            >
            </el-date-picker>
          </div>

          <el-table
            :data="ChartList"
            style="width: 100%"
            v-loading="chartLoading"
            class="rank_container"
          >
            <el-table-column
              class="rank"
              type="index"
              label="排名"
              width="130"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <img
                    v-if="scope.$index < 3 && chartPage.page_index === 1"
                    :src="
                      require('@/assets/images/home/' +
                        (scope.$index + 1) +
                        '.png')
                    "
                  />
                  <span v-else style="color: #e62126">{{
                    scope.$index +
                    (chartPage.page_index - 1) * chartPage.page_size +
                    1
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="!checknews ? '个人' : '部门'"
              width="330"
            >
              <template slot-scope="scope">
                <div style="display: flex" class="info">
                  <template v-if="!checknews">
                    <img
                      :src="
                        checkPath(scope.row.avatar_path)
                          ? scope.row.avatar_path
                          : BASE_URL + scope.row.avatar_path
                      "
                      style="border-radius: 30px"
                      v-if="scope.row.avatar_path"
                    />
                    <img
                      src="../../../../assets/images/home/no_head.png"
                      v-else
                    />
                  </template>
                  <div style="line-height: 40px; padding-left: 15px">
                    <span v-if="!checknews">{{ scope.row.name }} </span>
                    <span
                      :style="{ color: !checknews ? '#999999' : '#333' }"
                      style="padiing-left: 10px"
                      >{{ scope.row.org_name }}</span
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="学时">
              <template slot-scope="scope">
                <span style="color: #e62126"
                  >{{ parseInt(scope.row.total_time / 60) }}min</span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="chartPage.page_index"
              :page-size="6"
              layout="total, prev, pager, next, jumper"
              :total="total_number"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- <section class="i_application maxW clear">
      <div class="i_hTeacher wow fl slideInLeft">
        <div class="i_applicationTitle">
          <span>{{ $t('homepage.aboutUs') }}</span>
        </div>
        <div class="i_elegantDemeanor clear">
          <div class="i_companyImg fl">
            <img
              v-if="CampusStyleData.picture"
              :src="BASE_URL + CampusStyleData.picture"
            />
          </div>
          <div class="i_companyProfile">
            <div
              :class="CampusStyleData.content ? 'container' : 'container bgc'"
              v-html="CampusStyleData.content"
            ></div>
          </div>
        </div>
      </div>
      <div class="i_hNews fr">
        <div class="i_applicationTitle clear">
          <span>{{ $t("homepage.news") }}</span>
          <router-link to="/home/newsList">
            {{ $t("homepage.more") }}
            <i class="ipng el-icon-caret-right"></i>
          </router-link>
        </div>
        <div class="i_hNewsBox">
          <div
            class="i_testBox i_scorbar clear"
            id="news_list"
          >
            <div
              class="i_testTab"
              v-for="(item, index) of newsData"
              :key="index"
            >
              <input
                type="radio"
                class="i_testRadio"
                :checked="index == checknews"
              />
              <label
                class="i_testLabel"
                @click="getNewsList(item.id, index)"
              >{{
                item.name
              }}</label>
              <div class="i_tabContent">
                <ul>
                  <template v-for="(item1, index1) of newsListData">
                    <li
                      v-if="item1"
                      class="i_hNotice clear"
                      :key="index1"
                    >
                      <router-link :to="{
                          path: '/home/newsDetail',
                          query: { id: item1.id },
                        }">{{ item1.name }}
                      </router-link>
                      <strong v-html="formatTime1(item1.update_time)"></strong>
                    </li>
                    <li
                      v-else
                      class="i_hNotice clear"
                      :key="item1"
                    ></li>
                  </template>
                </ul>
              </div>
            </div>
            <img
              v-if="newsData.length == 0"
              :src="noneNoticeUrl"
            />
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  props: {
    pathOption: {
      personal: "", //个人中心跳转路径
      manage: "", //后台跳转路径
    },
  },
  data() {
    return {
      loading: false,
      //组织架构模块，选中了学校的时候，获取地址栏的CheckSchoolAppCode参数
      CheckSchoolAppCode:
        this.$route.query.CheckSchoolAppCode == undefined
          ? "00000000000000000000000000000000"
          : this.$route.query.CheckSchoolAppCode,
      userId: this.$g.user_id,
      carouselPicData: [],
      applicationData: [],
      hotVideoData: [],
      errorImg:
        'this.src="' + require("@/assets/images/image_loding.png") + '"',
      teacherCenterData: [],
      newsData: [],
      newsListData: [],
      newsActiveName: "0",
      checknews: 0,
      CampusStyleData: [],
      hostURL: "",
      specialareaArr: [],
      productArr: [],
      niceVideoArr: [],
      homeSet: {
        ranking_show: false,
        aboutus_show: false,
        special_show: false,
        product_show: false,
        hotvideo_show: true,
        nicevideo_show: false,
      },
      noticeData: [
        // {
        //   data: '2022',
        //   time: '09-20',
        //   name: '【获奖喜报】保伦电子itc荣获共安全优秀共安全优秀安全优秀安全优秀',
        //   detail: 'itc会议系统主机荣获2021公共安全优tc荣获共安全优秀共安全优秀安全优秀安全优秀'
        // },
        // {
        //   data: '2022',
        //   time: '09-20',
        //   name: '【获奖喜报】保伦电子itc荣获共安全优秀共安全优秀安全优秀安全优秀',
        //   detail: 'itc会议系统主机荣获2021公共安全优tc荣获共安全优秀共安全优秀安全优秀安全优秀'
        // }, {
        //   data: '2022',
        //   time: '09-20',
        //   name: '【获奖喜报】保伦电子itc荣获共安全优秀共安全优秀安全优秀安全优秀',
        //   detail: 'itc会议系统主机荣获2021公共安全优tc荣获共安全优秀共安全优秀安全优秀安全优秀'
        // }
      ],
      chartData: [
        { name: "个人排行", id: 1 },
        { name: "部门排行", id: 2 },
      ],
      dialogVisible: false,
      CardList: [],
      ChartList: [
        // { id: 1, name: '杨明昊', dept: '特战团队-上海-上海3部', min: '300' },
        // { id: 1, name: '杨明昊', dept: '特战团队-上海-上海3部', min: '300' },
        // { id: 1, name: '杨明昊', dept: '特战团队-上海-上海3部', min: '300' },
        // { id: 1, name: '杨明昊', dept: '特战团队-上海-上海3部', min: '300' },
      ],
      tableData: [],
      chartLoading: false,
      dataPreMonth: null,
      chartPage: {
        page_index: 1,
        page_size: 6,
      },
      total_number: 0,
      isfirst: true,
      rankText: "",
    };
  },
  watch: {
    // dataPreMonth(val) {
    //   this.getChartList(this.checknews + 1, this.checknews)
    // }
  },
  created() {
    this.hostURL = sessionStorage.getItem("host_addr");
    this.getCarouselPic();
    this.getHomeSet();
    this.hotVideo();
    this.getProduct();
    this.getspecialarea();
    this.getNiceVideo();
    this.teacherCenter();
    this.news();
    this.CampusStyle();
    this.getPreMonth(true);
  },
  mounted() {
    // setTimeout(() => {
    //   this.loading = false
    // }, 1500)
  },
  computed: {
    noneNoticeUrl() {
      return `${this.hostURL}/static/default/news_preview.png`;
    },
    noneDataUrl() {
      return this.$i18n.locale === "en-us"
        ? require("@/assets/images/none_data.png")
        : require("@/assets/images/none_data_cn.png");
    },
  },
  methods: {
    onDatePicker(val) {
      this.getChartList(this.checknews + 1, this.checknews);
    },
    checkPath(url) {
      const regex = /^(http|https):\/\//;
      const isValid = regex.test(url);
      return isValid;
    },

    getRank() {
      // 获取当前月份
      const timeArr = this.dataPreMonth.split("-");
      const dataObj = {
        year: timeArr[0],
        month: +timeArr[1],
      };
      const success = (res) => {
        this.rankText = res.data.sort;
      };
      this.$ajax.get("/api/videoviews/video_views_ranking", {
        params: {
          type: this.checknews + 1,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
          ...dataObj,
        },
        func: { success },
      });
    },

    showModel() {
      this.dialogVisible = true;
      this.chartPage.page_index = 1;
      this.getChartList(this.checknews + 1, this.checknews);
    },
    getPreMonth() {
      let success = (res) => {
        this.dataPreMonth =
          res.data.year +
          "-" +
          (res.data.w_m < 10 ? "0" + res.data.w_m : res.data.w_m);
        this.getChartList(1, 0);
      };
      this.$ajax.get("/api/videoviews/get_week_month", {
        params: { type: 4 },
        func: { success },
      });
    },
    /***********排行榜  对应的列表 */
    getChartList(id, index, type) {
      if (type === "card" || type === "table") {
        this.isfirst = true;
        this.chartPage.page_index = 1;
        this.CardList = [];
      }
      this.chartLoading = true;
      this.checknews = index;
      this.ChartList = [];
      let url =
        id === 1
          ? "api/videoviews/video_views_user_month"
          : "api/videoviews/video_views_department_month";
      let timeArr = this.dataPreMonth.split("-");
      let dataObj = {
        year: timeArr[0],
        month: +timeArr[1],
      };
      this.getRank();
      let success = (res) => {
        this.ChartList = res.data.data;
        if (res.data.data.length && this.isfirst) {
          this.CardList = res.data.data.slice(0, 3);
          this.isfirst = false;
        }
        this.total_number = res.data.data_sum;
        this.chartLoading = false;
      };
      this.$ajax({
        url: url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          DecisionPlatform: "logintable",
        },
        method: "get",
        params: {
          ...this.chartPage,
          ...dataObj,
        },
        func: {
          success: success,
        },
      });
    },

    handleClose(done) {
      done();
    },
    handleSizeChange(val) {
      console.log("val222222-----", val);
      this.chartPage.page_index = 1;
      this.chartPage.page_size = val;
      this.getChartList(this.checknews + 1, this.checknews);
    },
    handleCurrentChange(val) {
      console.log("11111111-----", val);
      this.chartPage.page_index = val;
      this.getChartList(this.checknews + 1, this.checknews);
    },
    getHomeSet() {
      let success = (res) => {
        const { aboutus_show, ranking_show } = res.data;
        this.homeSet.special_show = res.data.special_show == 1;
        this.homeSet.product_show = res.data.product_show == 1;
        this.homeSet.hotvideo_show = res.data.hotvideo_show == 1;
        this.homeSet.nicevideo_show = res.data.nicevideo_show == 1;
        this.homeSet.aboutus_show = aboutus_show == 1;
        this.homeSet.ranking_show = ranking_show == 1;
      };
      this.$ajax.get("/api/setting/index_app_show", {
        params: { type: 0 },
        func: { success: success },
      });
    },
    // 专项训练营
    getspecialarea() {
      let success = (data) => {
        this.specialareaArr = new Array(8);
        for (let inx in data.data) {
          this.specialareaArr[inx - 1] = data.data[inx];
        }
      };
      this.$ajax.get("/api/arrondi/get_home_position_arrondi", {
        params: { type: 1, is_limit: 1 },
        func: { success },
      });
    },
    //产品课程
    getProduct() {
      let success = (data) => {
        this.productArr = new Array(8);

        for (let inx in data.data) {
          this.productArr[inx - 1] = data.data[inx];
        }

        this.productArr.forEach((item) => {
          if (item.avatar_path) {
            item.avatar_path = this.checkPath(item.avatar_path)
              ? item.avatar_path
              : this.BASE_URL + item.avatar_path;
          } else {
            item.avatar_path =
              this.BASE_URL + "/static/default/user_preview-1.png";
          }
        });
      };
      this.$ajax.get("/api/arrondi/get_home_position_arrondi", {
        params: { type: 2, is_limit: 1 },
        func: { success },
      });
    },
    // 精品推荐
    getNiceVideo() {
      let success = (data) => {
        this.niceVideoArr = new Array(8);
        for (let inx in data.data) {
          this.niceVideoArr[inx - 1] = data.data[inx];
        }

        this.niceVideoArr.forEach((item) => {
          if (item.avatar_path) {
            item.avatar_path = this.checkPath(item.avatar_path)
              ? item.avatar_path
              : this.BASE_URL + item.avatar_path;
          } else {
            item.avatar_path =
              this.BASE_URL + "/static/default/user_preview-1.png";
          }
        });
      };
      this.$ajax.get("/api/arrondi/get_home_position_arrondi", {
        params: { type: 3, is_limit: 1 },
        func: { success },
      });
    },

    setActiveIndex() {
      const success = (res) => {
        const activeItem = res.data.find((item) => {
          const key = "albumList";
          if (item.url.includes(key)) {
            return item;
          }
        });
        window.sessionStorage.setItem("activeIndex", activeItem.id - 1);
        this.$store.commit("SET_ACTIVEINDEX", activeItem.id - 1);
      };

      this.$ajax.get("api/system/get_home_menu_cansee", {
        params: {},
        func: {
          success: success,
        },
      });
    },

    // 专项训练营/产品课程 跳转到 视频、专辑详情
    goToDetails(item) {
      if (item.origin) {
        this.setActiveIndex();
        return this.$router.push({
          path: "/home/albumDetail",
          query: { id: item.res_id },
        });
      }

      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll();
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          this.$router.push({
            path: "/home/openclassDetail",
            query: { id: item.res_id },
          });
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: 1,
          type_id: item.res_id,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
        },
        func: { success },
      });
    },

    // 跳转到视频详情页
    turnDetails(item) {
      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll();
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          this.$router.push({
            path: "/home/openclassDetail",
            query: {
              id: item.resid,
            },
          });
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: 1,
          type_id: item.resid,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
        },
        func: { success },
      });
    },
    //轮播图
    getCarouselPic() {
      let success = (res) => {
        this.carouselPicData = res.data;
      };
      this.$ajax({
        url: "api/carousel/manage_banners",
        method: "get",
        params: { module: 1 },
        func: {
          success: success,
        },
      });
    },
    /**  应用图标的点击事件
     * @param url 前台应用跳转地址
     * @param jumpModel '跳转方式 1：直接跳转（本平台以内的）  2验证跳转（参考跳转到前台） 3（验证跳转到个人中心） 4 直接跳转（本平台以外的）'
     * @param isDefault 是否是默认应用 1：是；0：不是（注默认应用不验证权限，登录 除对话，发评论等需登录的功能外）
     * @param id 应用id
     * @param trueUrl 其他系统模块应用跳转地址
     * @param isNewFrom 0：当前窗口打开；1：新窗口打开
     */
    checkRole(url, jumpModel, isDefault, id, trueUrl, isNewFrom) {
      if (url == "") {
        this.$message.error(this.$t("homepage.noOpen"));
        return;
      }
      if (isDefault != 1) {
        if (this.userId == 0) {
          this.$message.error(this.$t("homepage.needLogin"));
          return;
        }
        if (
          !is_empty(this.$store.getters.userInfo) &&
          this.$store.getters.userInfo.role.indexOf(7) > -1
        ) {
          this.$message.error(this.$t("homepage.Visitors"));
          return;
        }
        this.checkNode(url, jumpModel, isDefault, id, trueUrl, isNewFrom);
      } else {
        this.addAppVisitRecord(id);
        if (jumpModel == 1 || jumpModel == 2) {
          switch (url) {
            case "/index/resource/index":
              url = "home/resourceList";
              break;
            case "live":
              url = "home/liveList";
              break;
            case "album":
              url = "home/albumList";
              break;
            case "openclass":
              url = "home/openclassList";
              break;
            case "teachcenter":
              url = "teach";
              break;
            case "email":
              url = "email/inbox";
              break;
            case "ask":
              url = "teach/ask";
              break;
          }
          if (isNewFrom == 0) {
            this.$router.push({
              path: "/" + url,
              query: {
                CheckSchoolAppCode: this.CheckSchoolAppCode,
              },
            });
          } else {
            const { href } = this.$router.resolve({
              path: "/" + url,
              query: {
                CheckSchoolAppCode: this.CheckSchoolAppCode,
              },
            });
            window.open(href, "_blank");
          }
        }
        // 跳个人中心
        else if (jumpModel == 3) {
          let urlString = this.pathOption.personal + "&routerUrl=" + url;
          isNewFrom == 0
            ? (window.location.href = urlString)
            : window.open(urlString, "_blank");
        }
        //跳其他系统模块
        else if (jumpModel == 4) {
          if (trueUrl == "" || trueUrl == null || trueUrl == false) {
            this.$message.error(this.$t("homepage.noOpen"));
            return;
          }
          isNewFrom == 0
            ? (window.location.href = url)
            : window.open(url, "_blank");
        }
      }
    },
    // 检验跳转权限
    checkNode(url, jumpModel, isDefault, id, trueUrl, isNewFrom) {
      let success = (res) => {
        this.addAppVisitRecord(id);
        // 跳前台
        if (jumpModel == 1 || jumpModel == 2) {
          switch (url) {
            case "/index/resource/index":
              url = "home/resourceList";
              break;
            case "live":
              url = "home/liveList";
              break;
            case "album":
              url = "home/albumList";
              break;
            case "openclass":
              url = "home/openclassList";
              break;
            case "teachcenter":
              url = "teach";
              break;
            case "email":
              url = "email/inbox";
              break;
            case "ask":
              url = "teach/ask";
              break;
          }
          if (isNewFrom == 0) {
            this.$router.push({
              path: "/" + url,
              query: {
                CheckSchoolAppCode: this.CheckSchoolAppCode,
              },
            });
          } else {
            const { href } = this.$router.resolve({
              path: "/" + url,
              query: {
                CheckSchoolAppCode: this.CheckSchoolAppCode,
              },
            });
            window.open(href, "_blank");
          }
        }
        // 跳个人中心
        else if (jumpModel == 3) {
          let urlString = this.pathOption.personal + "&routerUrl=" + url;
          isNewFrom == 0
            ? (window.location.href = urlString)
            : window.open(urlString, "_blank");
        }
        //跳其他系统模块
        else if (jumpModel == 4) {
          if (trueUrl == "" || trueUrl == null || trueUrl == false) {
            this.$message.error(this.$t("homepage.noOpen"));
            return;
          }
          isNewFrom == 0
            ? (window.location.href = url)
            : window.open(url, "_blank");
        }
      };
      this.$ajax.get("/api/login/checkthisnode", {
        params: {
          url: url,
          token: localStorage.getItem("token"),
          checkschoolappcode: this.CheckSchoolAppCode,
        },
        func: {
          success: success,
        },
      });
    },
    /** 添加应用访问记录
     * @param id 应用id
     */
    addAppVisitRecord(id) {
      let success = (res) => {};
      this.$ajax({
        url: "/api/app/add_app_visit_record",
        method: "post",
        data: {
          app_id: id,
        },
        func: {
          success: success,
        },
      });
    },

    showNoticeDetail(data) {
      this.$router.push({
        path: "/home/newsDetail",
        query: { id: data.id },
      });
    },

    // 热门推荐
    hotVideo() {
      let success = (res) => {
        // 数据不够8个的话，给空的，为了在模板遍历的时候够8次，显示占位符效果
        this.hotVideoData = new Array(8);
        for (let inx in res.data) {
          this.hotVideoData[inx - 1] = res.data[inx];
        }
        this.hotVideoData.forEach((item) => {
          if (
            item.avatar_path.includes("/static/default/user_preview-1.png") ||
            item.avatar_path.includes("/public/picture")
          ) {
            item.avatar_path = this.BASE_URL + item.avatar_path;
          }
        });
      };
      this.$ajax({
        url: "api/video/get_home_position_video",
        method: "get",
        params: {
          is_limit: 1,
          page_index: 1,
          page_size: 8,
          order_type: "click",
        },
        func: {
          success: success,
        },
      });
    },
    // 名师中心：
    teacherCenter() {
      let success = (res) => {
        this.teacherCenterData = new Array(10);
        res.data.forEach((item, inx) => {
          this.teacherCenterData[inx] = res.data[inx];
        });
      };
      this.$ajax({
        url: "api/user/index_master",
        method: "get",
        params: {
          page: 1,
          size: 10,
          is_famous: 1,
          status: 1,
        },
        func: {
          success: success,
        },
      });
    },
    // 获取新闻公告标题：
    news() {
      let success = (res) => {
        this.newsData = res.data;
        if (res.data[0]) {
          this.getNewsList(res.data[0].id, 0);
        }
      };
      this.$ajax({
        url: "api/news/news_category",
        method: "get",
        params: {
          page_index: 1,
          page_size: 3,
          status: 1,
        },
        func: {
          success: success,
        },
      });
    },
    // 获取新闻公告标题id对应的列表：
    getNewsList(_id, _index) {
      this.checknews = _index;
      let success = (res) => {
        this.newsListData = new Array(4);
        // this.noticeData=res.data.data.data
        if (res.data.data.length) {
          this.noticeData = res.data.data.map((item, inx) => {
            this.newsListData[inx] = res.data.data[inx];
            let dataArr = item.create_time.split(" ")[0].split("-");
            return {
              ...item,
              time: dataArr[1] + "-" + dataArr[2],
              data: dataArr[0],
            };
          });
          // this.noticeData = res.data.data
          return;
        }
        this.noticeData = [];
      };
      this.$ajax({
        url: "api/news/news_list",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          DecisionPlatform: "logintable",
        },
        method: "get",
        params: {
          page_index: 1,
          page_size: 4,
          category_id: _id,
          // order: "sort"
          order: "top",
        },
        func: {
          success: success,
        },
      });
    },
    // 校园风采：
    CampusStyle() {
      let success = (res) => {
        this.CampusStyleData = res.data;
      };
      this.$ajax({
        url: "api/setting/school_culture",
        method: "get",
        params: {},
        func: {
          success: success,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$bg_3: #ffffff; //white - bg
$shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
$shadow2: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
$sc_6: #e62125; //Main color
$font: 16px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1, Tahoma;

.avatat_span {
  margin-right: 5px;
  img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
  }
}

.rank_container {
  :deep(.el-table__header) {
    tr {
      th {
        font-weight: bold;
        color: #000;
        background-color: #f2f3f7;
      }
    }
  }
}

.home-carousel {
  position: relative;
  width: 100%;
  min-height: 20px;
  background-color: #fff;

  &::after {
    z-index: 98;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 20px;
    display: block;
    background: linear-gradient(
        -45deg,
        transparent 33.33%,
        #fff 33.33%,
        #fff 66.666%,
        transparent 66.666%
      ),
      linear-gradient(
        45deg,
        transparent 33.33%,
        #fff 33.33%,
        #fff 66.666%,
        transparent 66.666%
      );
    background-size: 12px 60px;
    transform: rotate(180deg);
  }
}

.home .i_hotType {
  color: #666;

  .demand_cate {
    float: right;
    margin-top: 14px;
    width: 87px;
    padding: 0 5px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #e8e9e9;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #727e90;
    line-height: 24px;
    text-align: center;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap;
  }
}

.home .i_speType {
  padding: 0 10px;
  height: 50px;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #727e90;
  margin-bottom: 5px;

  .speCate {
    display: flex;
    align-items: center;
    flex: 4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sawPeo {
    flex: 1;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.home .originCte {
  line-height: 25px;
  text-align: center;
  width: 50px;
  height: 25px;
  border-radius: 0px 0px 0px 20px;
  background-color: #e62125;
  font-style: italic;
  font-style: oblique;
  color: #fff;
  position: absolute;
  top: 0px;
  right: 0px;
}

.home .spePholder {
  margin: 150px 0 30px;
  /* border-top: 5px solid #effaff;
  border-bottom: 5px solid #effaff; */
  height: 50px;
}

.home .i_application .i_hNews .i_hNewsBox {
  position: relative;

  #news_list {
    height: 100%;

    > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.i_transition {
  -moz-transition: all 0.35s ease-in;
  -webkit-transition: all 0.35s ease-in;
  -o-transition: all 0.35s ease-in;
  transition: all 0.35s ease-in;
}

.home .pointer {
  cursor: pointer;
}

.resources-container-home {
  .resource-card-box {
    display: inline-block;
    width: 100%;
    // width: 940px;

    .cards-box-ul {
      width: 100%;
      // height: 749px;
    }

    .cards-li {
      width: 257px;
      height: 140px;
      background: $bg_3;
      padding: 23/1200 * 100% 21/1200 * 100% 17/1200 * 100% 12/1200 * 100%;
      -webkit-box-shadow: $shadow2;
      -moz-box-shadow: $shadow2;
      box-shadow: $shadow2;
      -moz-border-radius: 3px;
      border-radius: 3px;
      @extend .i_transition;
      margin: 0 13px 20px 0;

      &:nth-of-type(4n) {
        margin: 0 0 20px 0;
      }

      &:hover {
        -webkit-box-shadow: $shadow;
        -moz-box-shadow: $shadow;
        box-shadow: $shadow;

        .cards-li-title {
          .res-title {
            color: $sc_6;
          }
        }
      }
    }

    .cards-li-title {
      .res-title {
        display: block;
        float: left;
        font: $font;
        line-height: 22px;
        width: 74%;
        height: 48px;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    .user-infos {
      position: relative;

      > span {
        line-height: 25px;
        display: inline-block;
        font-size: 12px;

        > span {
          display: inline-block;
          vertical-align: middle;
          width: 25px;
          height: 25px;
          -moz-border-radius: 50%;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 5px;

          > img {
            width: 100%;
            height: 100%;
          }
        }

        .resource_cate {
          display: block;
          position: absolute;
          right: 0px;
          top: 0px;
          width: 87px;
          padding: 0 5px;
          height: 24px;
          border-radius: 4px;
          border: 1px solid #e8e9e9;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #727e90;
          line-height: 24px;
          text-align: center;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
      }
    }

    .rate-star {
      line-height: 19px;
      margin: 30/260 * 100% 0 16px 0;
    }

    .rate-score {
      > strong {
        float: left;
        margin-left: 12px;
        color: #ff6525;
      }
    }

    .collect {
      .praise {
        background-position: -544px -782px;
        width: 14px;
        height: 14px;
      }

      > i {
        vertical-align: middle;
      }

      > strong {
        color: #888;
        margin-left: 5px;
      }
    }
  }

  .dependent {
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #fff;

    > i {
      margin: 100px 0 30px;
    }

    > p {
      padding-bottom: 30px;
      color: #999;
    }
  }

  .pageBox {
    margin-top: 24px;
  }

  .resource-rank {
    display: inline-block;
    width: 240px;
    height: 807px;
    background-color: #fff;

    .upload-btn-div {
      height: 52px;
      line-height: 52px;
      text-align: center;
      color: #fff;
      background-color: #338efc;
      cursor: pointer;

      .icon_up {
        margin-right: 5px;
      }

      i {
        vertical-align: middle;
      }
    }

    .box-card {
      border: none;

      .humantitle {
        padding: 5px 8px;
        border-radius: 2px;
        font-size: 14px;
        color: #666;
      }

      .el-card__header {
        padding: 16px 10px;
        margin: 0 8px;
        border-bottom: solid 2px #e5e5e5;
      }

      .el-card__body {
        height: 299px;
        padding: 14px 20px;
      }

      .humanItem {
        padding: 5px 0;
      }

      .humanItem i {
        border-radius: 4px;
      }

      .humanItem a {
        display: inline-block;
        width: 80%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .humanItem:hover {
        background-color: #effaff;
      }

      .humanItem:hover > a {
        color: #e62125;
      }

      .humanNun {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
        background: #d2d2d2;
        margin-right: 10px;
      }

      .humanNun.yellowC {
        background: #f2b732;
      }
    }

    .upload-rank .el-card {
      border-bottom: 1px dashed #d7d7d7;
    }
  }

  .no-data {
    color: #ccc;
    text-align: center;
    padding: 70px 0;
  }
}

.ranktext {
  color: red;
  font-size: 16px;
  margin-bottom: 16px;
  margin-left: 20px;
}

.chart_more {
  font-size: 12px;
  color: #e62125;
  line-height: 23px;
  display: flex;
  padding-left: 10px;
  margin-left: 87%;
  background-color: #ffdbe4;
  border-radius: 10px;

  .ipng {
    margin: 7px 0 0 6px;
    color: #e62125;
  }
  i {
    padding-right: 5px;
  }

  > span {
    &:hover {
      color: #aa0609;
    }
  }
}

.class_hour {
  width: 100%;
  height: 220px;
  display: flex;
  background-color: #fff;
  margin: 20px 0;
  overflow: hidden;

  .nav_title {
    min-width: 180px;
    height: 220px;

    // width: 100%;
    // padding-top: 30px;
    background: #2c2e3f;

    .title {
      margin: 0 auto;
      text-align: center;
      line-height: 110px;
      color: #fff;
      font-size: 16px;
      // margin-top: 15px;
      width: 100%;
      height: 50%;
    }

    .checked {
      background: #e62126;
    }
  }

  .content {
    padding: 40px 40px 0 30px;
    width: 100%;
    overflow: hidden;
    height: 170px;

    .row {
      font-size: 16px;
      display: grid;

      grid-template-columns: 15% 25% 45% 10%;
      grid-template-rows: 10px;
      // justify-content: space-around;
      height: 65px;
      align-items: center;
      width: 100%;

      > img:nth-child(1) {
        width: 50px;
        height: 50px;
      }

      .name_d {
        display: flex;
        color: #2c2e3f;
        font-family: MicrosoftYaHei;

        span {
          line-height: 28px;
          padding-left: 10px;
        }

        img {
          width: 30px;
          height: 30px;
        }
      }

      .min {
        color: #e62126;
        font-weight: bold;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
    }
  }
}

.notice_d {
  width: 100%;
  height: 220px;
  display: flex;
  background-color: #fff;
  margin: 20px 0;
  overflow: hidden;

  .nav_title {
    min-width: 180px;
    height: 220px;
    // width: 100%;
    padding-top: 30px;
    background: linear-gradient(270deg, #f4454c 0%, #e62125 100%);

    .title {
      margin: 0 auto;
      text-align: center;
      line-height: 34px;
      color: #fff;
      font-size: 16px;
      margin-top: 15px;
      width: 140px;
      height: 34px;
      border-radius: 17px;
    }

    .checked {
      color: #e62125;
      background: #ffffff;
    }
  }

  .content {
    // margin-left: 200px;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: 10px;

    .grid-item {
      // background-color: #F5F6FA;
      padding: 15px 20px;
      text-align: start;
      display: flex;

      .left_d {
        // width: 80px;
        // height: 50px;
        position: relative;

        .text {
          span {
            font-size: 14px;
            line-height: 16px;
            color: #ffffff;
            display: block;
          }
        }
      }

      .title {
        width: 380px;
        font-weight: bold;
        font-size: 16px;
        line-height: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .detail {
        width: 380px;
        height: 18px;
        line-height: 20px;
        color: #666666;
        font-size: 14px;
        padding-top: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.about_d {
  position: relative;
  width: 100%;
  height: 500px;
  background-color: #2c2e3f;

  .red_bg {
    position: absolute;
    right: 0;
    top: 0;
    width: 50%;
    height: 500px;
    z-index: 99;
    background-color: #b41c1b;
  }

  .content {
    position: absolute;
    display: flex;
    left: 50%;
    transform: translate(-50%);
    z-index: 99999;
    width: 100%;
    overflow: hidden;
    height: 420px;
    background-color: #fff;

    .i_companyImg {
      width: 50%;
      height: 327px;
      margin: 0;

      img {
        width: 100%;
        height: 100;
      }

      .name {
        position: absolute;
        bottom: 40px;
        font-size: 16px;
        right: 30px;
      }

      .text {
        position: absolute;
        bottom: 20px;
        font-size: 16px;
        right: 30px;
        height: 6px;
        width: 28px;
        background-color: #e62126;
      }
    }

    .text_content {
      padding: 50px 30px;
      width: 45%;
    }

    .itc_content {
      margin-top: 10px;
      line-height: 26px;
      height: 315px;
      overflow-y: scroll;
    }

    .title {
      color: #b41c1b;
      font-weight: bold;
    }

    .en {
      font-size: 14px;
      padding-left: 10px;
      color: #bbbbbb;
    }
  }
}

:deep(.el-dialog__body) {
  padding: 0 !important;
}

:deep(.el-dialog__header) {
  background-color: #fff !important;
  text-align: center;
  border-bottom: 1px solid #f5f5f5;
  padding: 20px !important;
}

:deep(.el-dialog__title) {
  color: #e62126 !important;
  font-size: 18px !important;
  line-height: 25px;
  width: 50%;
}
:deep(.el-dialog__close) {
  color: #909399 !important;
}

.chart_class {
  width: 20%;
  height: 630px;

  background-color: #2c2e3f;

  .title {
    margin: 0 auto;
    text-align: center;
    line-height: 55px;
    color: #fff;
    font-size: 16px;
    // margin-top: 15px;
    width: 100%;
    height: 55px;
    cursor: pointer;
  }

  .checked {
    background: #e62126;
  }
}

.chart_table {
  width: 80%;
  padding-top: 60px;

  img {
    width: 50px;
    height: 50px;
  }

  .info {
    img {
      width: 40px;
      height: 40px;
      border-radius: 30px;
    }
  }

  .block {
    position: absolute;
    bottom: 30px;
    left: 60%;
    transform: translate(-50%);
  }

  .month_input {
    float: left;
    width: 120px;
    margin-left: 10px;

    & :deep(.el-input__inner) {
      border: none;
    }
  }
}
</style>
